import OAuthService from './oAuthService';

export default OAuthService;
